import { render, staticRenderFns } from "./CreateProjectModal.vue?vue&type=template&id=b90de1fa&scoped=true&"
import script from "./CreateProjectModal.vue?vue&type=script&lang=js&"
export * from "./CreateProjectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90de1fa",
  null
  
)

export default component.exports